import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { Shipment } from '../../core/api/lab.types';

export const getShipmentHasErrorSelector = (state: RootState): boolean =>
  state.getShipment.errors && state.getShipment.errors ? true : false;

export const getShipmentIsBusySelector = (state: RootState): boolean => state.getShipment.status === StoreStatus.BUSY;

export const getShipmentResponseSelector = (state: RootState): Shipment | null => state.getShipment.response || null;
